import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import loginToken from "../authComponents/localStorageItems/LoginTokin";
const Navbar = ({ userRole, setLoginPopUp }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const handleLogOut = () => {
    localStorage.removeItem("authToken");
    window.location.reload();
  };
  const handleLoginPopUp = () => {
    if (!loginToken) {
      setLoginPopUp(true); // Show popup instead of navigating
    }
  };
  return (
    <nav className="bg-white shadow-md w-full sticky top-0 left-0 z-50">
      <div className="px-5 mx-auto px-4 flex justify-between items-center">
        {/* Logo Section */}
        <Link to="/">
          <img src={logo} className="w-20 h-20 p-2" />
        </Link>

        {/* Hamburger Menu for Mobile */}
        <div className="md:hidden">
          <button onClick={toggleMenu} className="text-2xl text-[#730000]">
            {isOpen ? (
              <FaTimes className="w-6 h-6" />
            ) : (
              <FaBars className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Navigation Links */}
        <ul
          className={`md:flex md:space-x-4 text-black text-sm max-md:text-[16px] uppercase font-semibold absolute md:static left-0 w-full md:w-auto bg-white md:bg-transparent md:py-0 py-4 transition-all duration-300 ease-in-out ${
            isOpen ? "top-16 opacity-100" : "-top-96 opacity-0"
          } md:opacity-100`}
        >
          <Link to="/">
            <li className="hover:text-[#730000] cursor-pointer text-center md:text-left py-2">
              Home
            </li>
          </Link>
          <Link to="/about">
            <li className="hover:text-[#730000] cursor-pointer text-center md:text-left py-2">
              About
            </li>
          </Link>
          <Link to="/contact">
            <li className="hover:text-[#730000] cursor-pointer text-center md:text-left py-2">
              Contact Us
            </li>
          </Link>
          <Link to="/profile">
            <li
              onClick={handleLoginPopUp}
              className="hover:text-[#730000] cursor-pointer text-center md:text-left py-2"
            >
              My Profile
            </li>
          </Link>
          {/* Conditional Rendering */}
          {loginToken && userRole === "admin" && (
            <Link to="/admin/dashboard">
              <li className="text-white rounded bg-[#730000] py-2 px-4 cursor-pointer text-center md:text-left">
                Dashboard
              </li>
            </Link>
          )}

          {!loginToken ? (
            <Link to="/login">
              <li className="text-white rounded bg-[#730000] py-2 px-4 cursor-pointer text-center md:text-left" style={{fontFamily: "serif"}}>
                Login/Register
              </li>
            </Link>
          ) : (
            <button
              onClick={handleLogOut}
              className="text-white rounded bg-[#730000] py-2 px-4 cursor-pointer text-center md:text-left"
            >
              Logout
            </button>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
